<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
        <b-row>
            <b-col cols="12">
                <FormInput 
                    type="text" 
                    label="NIF" 
                    name="nif" 
                    id="nif" 
                    rules="required" 
                    v-model="compania.nif" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="text" 
                    label="Nombre" 
                    name="nombre" 
                    id="nombre" 
                    rules="required" 
                    v-model="compania.nombre" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="text" 
                    label="Dirección" 
                    name="direccion" 
                    id="direccion" 
                    rules="required" 
                    v-model="compania.direccion" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="text" 
                    label="Ciudad" 
                    name="ciudad" 
                    id="ciudad" 
                    rules="required" 
                    v-model="compania.ciudad" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="number" 
                    label="Código Postal" 
                    name="cp" 
                    id="cp" 
                    rules="required|numeric" 
                    v-model="compania.cp" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="text" 
                    label="Cuenta" 
                    name="cuenta" 
                    id="cuenta" 
                    rules="required" 
                    v-model="compania.cuenta" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="email" 
                    label="Correo Electrónico" 
                    name="email" 
                    id="email" 
                    rules="required|email" 
                    v-model="compania.email" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="tel" 
                    label="Teléfono" 
                    name="telefono" 
                    id="telefono" 
                    rules="required|numeric" 
                    v-model="compania.telefono" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="number" 
                    label="IVA" 
                    name="iva" 
                    id="iva" 
                    rules="required|numeric" 
                    v-model="compania.iva" 
                />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput 
                    type="number" 
                    label="IVA Autores" 
                    name="iva_autores" 
                    id="iva_autores" 
                    rules="required|numeric" 
                    v-model="compania.iva_autores" 
                />
            </b-col>
            <b-col cols="12" :class="'mt-2 ' + (!compania.alerta_tpv ? 'mb-3' : '')">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="alerta_tpv" v-model="compania.alerta_tpv"/>
                    <label for="alerta_tpv" class="custom-control-label pt-1">Mostrar aviso del TPV en taquilla</label>
                </div>
            </b-col>
            <b-col cols="12" class="mt-3" v-if="compania.alerta_tpv">
                <FormInput 
                    type="text" 
                    label="Texto" 
                    name="texto_alerta_tpv" 
                    id="texto_alerta_tpv" 
                    rules="required" 
                    v-model="compania.texto_alerta_tpv" 
                />
            </b-col>
            <b-col cols="12" class="mt-2 mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="datafono_propio" v-model="compania.datafono_propio"/>
                    <label for="datafono_propio" class="custom-control-label pt-1">Datafono propio</label>
                </div>
            </b-col>
            <b-col cols="12" class="mt-2">
                <label class="d-flex justify-content-between align-items-center" for="tipo_tpv">
                    Tipo de TPV: <span class="mr-0"><small class="text-danger">*Si no selecciona ninguno, se usará el que hay por defecto</small></span>
                </label>
                <select class="w-100 form-control" name="tipo_tpv" id="tipo_tpv" v-model="compania.tipo_tpv">
                    <option value="" selected>No tiene TPV</option>
                    <option :value="1">Redsys</option>
                    <option :value="2">Paycomet</option>
                </select>
            </b-col>
            <b-col cols="12" class="mt-2" v-if="compania.tipo_tpv == 2">
                <FormInput label="N de terminal" type="number" name="n_terminal_paycomet" id="n_terminal_paycomet" rules="required" v-model="compania.tpv_numero_terminal_paycomet" />
                <FormInput label="API token" type="text" name="api_token_paycomet" id="api_token_paycomet" rules="required" v-model="compania.tpv_api_token" />
                <FormInput label="Jet id" type="text" name="jet_id_paycomet" id="jet_id_paycomet" rules="required" v-model="compania.tpv_jet_id" />
            </b-col>
            <b-col cols="12" class="mt-2" v-if="compania.tipo_tpv == 1">
                <FormInput label="N de comercio" type="number" name="n_comercio_redsys" id="n_comercio_redsys" rules="required" v-model="compania.tpv_numero_comercio" />
                <FormInput label="N de terminal" type="number" name="n_terminal_redsys" id="n_terminal_redsys" rules="required" v-model="compania.tpv_numero_terminal" />
                <FormInput label="Clave tpv" type="password" name="clave_redsys" id="clave_redsys" rules="required" v-model="compania.tpv_clave" />
            </b-col>
            <b-col v-if="error" cols="12" class="mt-2">
                <div class="alert alert-danger">
                    <b>{{ error }}</b>
                </div>
            </b-col>
            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" name="button">
                    CONTINUAR
                </Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['compania', 'error'],
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.compania.teatro_id = this.teatro.id;
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
    }
</script>